export const HOTKEYS = {
  focusIssueCommentComposer: 'r',
}
